import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useParams} from "react-router-dom";
import {usePaymentProfile} from "../hooks/usePaymentProfile.ts";
import {PaymentProfileStatus} from "../types.ts";

export const AddFormDrawer = ({ customerId: propCustomerId, billingProviderId: propBillingProviderId, ...props }: DrawerProps & { customerId?: string; billingProviderId?: string }) => {
    const {id: urlId} = useParams()
    const finalCustomerId = propCustomerId || urlId || '';

    const {
        createRecord,
    } = usePaymentProfile();

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                status: PaymentProfileStatus.Active,
                customerId: finalCustomerId,
                billingProviderId: propBillingProviderId || '',
                providerPaymentMethodId: '',
                created: new Date().toISOString(),
            }}
            handleSubmit={createRecord}
            {...props}
        />
    )
};